import { createHostDownload, type HostRoot } from "./hostWorkspace";

type PreparedDownload = {
  key: string;
  url: string;
  filename: string;
  expiresAt: number;
};

export class HostDragDownloadController {
  private prepared: PreparedDownload | null = null;
  private pending: { key: string; request: Promise<void> } | null = null;

  prepare(rootId: HostRoot["id"], path: string): Promise<void> {
    const key = downloadKey(rootId, path);
    if (this.prepared?.key === key && this.prepared.expiresAt > Date.now() + 2_000) return Promise.resolve();
    if (this.pending?.key === key) return this.pending.request;

    const request = createHostDownload(rootId, path)
      .then((download) => {
        this.prepared = { key, ...download };
      })
      .finally(() => {
        if (this.pending?.key === key) this.pending = null;
      });
    this.pending = { key, request };
    return request;
  }

  start(dataTransfer: DataTransfer, rootId: HostRoot["id"], path: string): boolean {
    const prepared = this.prepared;
    if (!prepared || prepared.key !== downloadKey(rootId, path) || prepared.expiresAt <= Date.now() + 2_000) return false;

    const filename = prepared.filename.replace(/[:\r\n]/g, "_");
    dataTransfer.effectAllowed = "copy";
    dataTransfer.setData("DownloadURL", `application/octet-stream:${filename}:${prepared.url}`);
    dataTransfer.setData("text/uri-list", prepared.url);
    return true;
  }
}

function downloadKey(rootId: HostRoot["id"], path: string) {
  return `${rootId}:${path}`;
}
